
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/inventory/charlynn",
      function () {
        return require("private-next-pages/en/inventory/charlynn.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/inventory/charlynn"])
      });
    }
  